import styled from "@emotion/styled";
import { Typography, Avatar, Badge, Row, Col, Divider } from "antd";
import { FC } from "react";
import { cartOrder, walletIncom } from "assets/icons";
import { useAppSelector } from "store";
import backgroundImage from "assets/images/BackgroundImage.svg";

const ProfilesHeader: FC = () => {
  const { profile, contact } = useAppSelector((state) => state.auth);
  return (
    <CardWrapper>
      {/* <IconHeader>
        <IconGroup>
          <IconWrapper>
            <SpanIcon>{cartOrder}</SpanIcon>
          </IconWrapper>
        </IconGroup>
      </IconHeader> */}
      <Row>
        <Col
          sm={{ span: 24 }}
          md={{ span: 12 }}
          xl={{ span: 8 }}
          style={{ width: "100%" }}
        >
          <WrapAvatarAndName>
            <Badge color={"green"} dot={true} offset={[-8, 50]}>
              <Avatar
                src={profile?.user.image_url}
                alt="avatar"
                style={{
                  objectFit: "cover",
                }}
                size={60}
                shape="circle"
              />
            </Badge>
            <TextWrapper>
              <Typography.Text className="text-order-agent-name">
               {contact?.name}
              </Typography.Text>
              {/* <Typography.Text style={{ fontSize: 14, color: "#A0A0A0" }}>
                {contact?.name}
              </Typography.Text> */}
            </TextWrapper>
          </WrapAvatarAndName>
        </Col>
        <Col
          sm={{ span: 24 }}
          md={{ span: 12 }}
          xl={{ span: 8 }}
          style={{ width: "100%" }}
        >
          {/* <CardIncome>
            <IconWallet>
              <SpanIcon>{walletIncom}</SpanIcon>
            </IconWallet>
            <TextInCardCenter>
              <Typography.Text style={{ fontSize: "14px", color: "#ffffff" }}>
                ยอดขายวันนี้
              </Typography.Text>
              <Typography.Text
                style={{ fontSize: "20px", color: "#ffffff", fontWeight: 500 }}
              >
                ฿300,000
              </Typography.Text>
            </TextInCardCenter>
            <TextInCardEnd>
              <Typography.Text style={{ fontSize: "14px", color: "#ffffff" }}>
                เมื่อวาน
              </Typography.Text>
              <Typography.Text
                style={{ fontSize: "16px", color: "#ffffff", fontWeight: 500 }}
              >
                ฿300,000
              </Typography.Text>
            </TextInCardEnd>
          </CardIncome> */}
        </Col>
        <Col
          sm={{ span: 24 }}
          md={{ span: 12 }}
          xl={{ span: 8 }}
          style={{ width: "100%" }}
        >
          {/* <RigntCard>
            <TextRightCard>
              <Typography.Text style={{ fontSize: "14px", color: "#A0A0A0" }}>
                คำสั่งซื้อที่ต้องยืนยัน
              </Typography.Text>
              <Typography.Text
                style={{ fontSize: "16px", color: "#000000", fontWeight: 400 }}
              >
                5 รายการ
              </Typography.Text>
            </TextRightCard>
            <Divider type="vertical" style={{ height: 55 }} />
            <TextRightCard>
              <Typography.Text style={{ fontSize: "14px", color: "#A0A0A0" }}>
                ตัวแทนที่จะมารับสินค้า
              </Typography.Text>
              <Typography.Text
                style={{ fontSize: "16px", color: "#000000", fontWeight: 400 }}
              >
                5 คน
              </Typography.Text>
            </TextRightCard>
          </RigntCard> */}
        </Col>
      </Row>
    </CardWrapper>
  );
};

export default ProfilesHeader;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 5px 0px 5px;
  background-color: #ffffff;
  border-radius: 0px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 21px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
  margin-bottom: 10px;
  margin-left: 10px;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const IconGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const IconHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  text-align: right;
`;

const WrapAvatarAndName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding: 0px 0px 10px 0px;
`;

const CardIncome = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #417B97;
  border-radius: 6px;
  padding: 10px 10px 10px 10px;
`;

// const ImageBackground = styled.img`
//   background-image: url(${backgroundImage});
//   background-size: cover;
//   height: 100%;
//   width: 100%;
//   background-repeat: no-repeat;
//   border: none;
//   border-radius: 10px;
// `;

const IconWallet = styled.div`
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TextInCardCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const TextInCardEnd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const RigntCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 10px 0px 0px 0px;
`;

const TextRightCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
